<template>
  <div class="area-select">
    <div class="wrap">
      <div class="content-inner">
        <div
          v-if="!value.record.length"
          class="ht"
        >
          请选择区域
        </div>
        <div
          v-if="value.record.length"
          class="rel-area"
        >
          常用区域：<br><a
            v-for="(item,index) in value.record"
            :key="'key-record-'+index"
            href="javascript:void(0)"
          >
            <template v-for="(city,idx) in item">
              <span
                v-if="idx==item.length-1"
                :key="'key-city-'+idx"
                @click="submit(item, true)"
              >{{ city[1] }}</span>
            </template>
          </a>
        </div>
        <div class="body clearfix">
          <template v-if="selectd_index==index">
            <div
              v-for="(city, index) in area"
              :key="'key-area-'+index"
              class="item"
            >
              <span
                v-for="(item,idx) in city"
                :key="'key-item-'+idx"
                class="hair-bottom"
                :class="{current:selected[index]==idx}"
                @click="getCity(item, index, idx)"
              >{{ item.name }}</span>
            </div>
          </template>
        </div>

        <!-- <div class="foot">
          <div color="primary" class="btn-submit" big @click="submit(selected)">确定</div>
          <div color="white" class="btn-cancel" big @click="close">返回</div>
        </div>
        <div class="close" @click="close">
            <img src="statics/close.png" alt="">
        </div> -->
      </div>
    </div>
    <div
      class="mask"
      @click="close"
    />
  </div>
</template>

<script>
import area from './js/area.js'

export default {
  components: {
  },
  props: ['value'],
  data () {
    return {
      area: [area],
      selected: [],
      confirm: '',
      selectd_index: 0
    }
  },
  mounted () {
    console.log(area)
  },
  methods: {
    submit (item, isrecord = false) {
      let confirm = []
      console.log(item)
      if (isrecord) {
        confirm = item
        this.selected = []
        this.area = [area]
      } else {
        item.map((v, i) => {
          confirm.push([v, this.area[i][v].name])
        })
      }

      let value = this.value
      value.show = false
      value.selected = confirm

      if (value.record.length) {
        let record = JSON.stringify(value.record)
        let c = JSON.stringify(confirm)
        if (!record.includes(c)) {
          value.record.push(confirm)
        }
      } else {
        value.record.push(confirm)
      }
      if (value.record.length > 5) {
        value.record.shift()
      }
      this.$emit('input', value)
      this.$emit('submit', confirm)
    },
    close () {
      this.$emit('close')
    },
    getCity (item, index, idx) {
      console.log(item, index, idx)
      this.area.splice(index + 1)
      this.selected.splice(index)
      this.selectd_index = index + 1
      this.$nextTick(() => {
        let node = document.querySelector('.area-select .body')
        node.scrollTop = 0
      })
      if (item.children) {
        this.area.push(item.children)
        this.selected.push(idx)
      }
      if (!Object.keys(item.children).length) {
        this.submit(this.selected)
      }
    }
  }
}
</script>

<style lang="stylus">
.area-select
  position absolute
  left 0
  right 0
  bottom 0
  top 0
  z-index 1000
  transition all 0.4s ease-in
  &.slide-right-enter-active
    .mask
      animation fadeIn 0.3s ease both
    .wrap
      animation fadeInRight 0.3s ease 0.1s both
  &.slide-right-leave-active
    .mask
      animation fadeOut 0.3s ease both
    .wrap
      animation fadeOutRight 0.3s ease both
  .wrap
    position absolute
    right 0
    top 0
    left 35%
    bottom 0
    background #ffffff
    z-index 1100
    // position relative
    // z-index 1100
    // background #fff
    // width 900px
    // margin 60px auto 0
    // border-radius 6px
    .content-inner
      position relative
      height 100%
      display flex
      flex-direction column
      .ht
        padding 0.2rem
        font-size 0.24rem
        color #808080
        background #eee
      .rel-area
        padding 0.2rem
        font-size 14px
        background #eee
        a
          display inline-block
          border 1px solid #ccc
          padding 0.05rem 0.15rem
          border-radius 0.05rem
          margin-right 0.1rem
          margin-bottom 0.1rem
          color #808080
          background #fff
          &:hover
            border-color #027be3
            background #027be3
            color #fff
      .body
        margin 0
        flex 1
        overflow-y scroll
        -webkit-overflow-scrolling touch
        .item
          // float left
          // border-right 1px solid #eee
          span
            display block
            padding 0.2rem
            font-size 0.28rem
            cursor pointer
            transition all 0.3s
            &.active
              color #fff
              background #027be3
      .foot
        padding 20px 30px
        background #f7f7f7
        border-top 1px solid #ededed
        border-radius 0 0 6px 6px
        text-align center
      .close
        position absolute
        right 20px
        top 20px
        opacity 0.5
        cursor pointer
        transition opacity 0.3s
        &:hover
          opacity 1
  .mask
    position fixed
    left 0
    right 0
    bottom 0
    top 0
    z-index 1000
    background rgba(0, 0, 0, 0.5)
</style>
